<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="edit" name="plantCd" v-model="searchParam.plantCd" />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept
            :editable="editable"
            label="팀명(반)"
            name="deptCd"
            :isFirstValue="false"
            v-model="searchParam.deptCd"
          >
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 안전보건 위험정보 목록 -->
    <c-table
      ref="processTable"
      title="안전보건 위험정보 목록"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      :isFullScreen="false"
      :usePaging="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable"
            label="등록"
            icon="add"
            @btnClicked="linkClick"
          />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskProcessManage",
  data() {
    return {
      editable: true,
      searchParam: {
        plantCd: null,
        useFlag: "Y",
        deptCd: "",
      },
      useFlagItems: [
        { code: "Y", codeName: "사용" },
        { code: "N", codeName: "미사용" },
      ],
      grid: {
        columns: [
          {
            name: "deptName",
            field: "deptName",
            label: "팀명(반)",
            align: "center",
            style: "width: 130px",
            sortable: false,
          },
          {
            name: "processName",
            field: "processName",
            label: "공정",
            type: "link",
            align: "left",
            style: "width: 200px",
            sortable: false,
          },
          {
            name: "mainMaterial",
            field: "mainMaterial",
            label: "원(재)료",
            style: "width: 100px",
            align: "left",
            sortable: false,
          },
          {
            name: "workerCnt",
            field: "workerCnt",
            label: "근로자수",
            style: "width: 80px",
            align: "right",
            sortable: false,
          },
          {
            name: "productName",
            field: "productName",
            label: "생산품기종",
            style: "width: 100px",
            align: "left",
            sortable: false,
          },
          {
            name: "orderNo",
            field: "orderNo",
            label: "순번",
            align: "right",
            style: "width: 70px",
            sortable: false,
          },
          {
            name: "useFlagName",
            field: "useFlagName",
            label: "사용여부",
            align: "center",
            style: "width: 70px",
            sortable: false,
          },
        ],
        data: [],
      },
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.riskProcess.list.url;
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.popupOptions.title = "안전보건 위험정보 상세";
      this.popupOptions.param = {
        riskProcessCd: row ? row.riskProcessCd : "",
      };
      this.popupOptions.target = () =>
        import(`${"./riskProcessManageDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
